import { Link } from "@tanstack/react-router";

import { cn } from "@/lib/utils";

/**
 * Marca institucional MEDAM.
 * Para usar el logotipo oficial, coloca el archivo en src/assets/logo-medam.png,
 * impórtalo aquí y reemplaza el bloque del monograma por <img src={logo} ... />.
 */
export function Marca({
  className,
  invertido = false,
}: {
  className?: string;
  invertido?: boolean;
}) {
  return (
    <Link to="/" className={cn("group inline-flex items-center gap-3", className)}>
      <img src="/logo192.png" alt="MEDAM" className="size-10 rounded-xl object-contain" />
      <span className="leading-tight">
        <span
          className={cn(
            "block font-display text-lg font-semibold tracking-tight",
            invertido ? "text-sidebar-foreground" : "text-foreground",
          )}
        >
          MEDAM
        </span>
        <span
          className={cn(
            "block text-[11px] uppercase tracking-[0.22em]",
            invertido ? "text-sidebar-foreground/70" : "text-muted-foreground",
          )}
        >
          Nueva etapa
        </span>
      </span>
    </Link>
  );
}
